// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__ezMMB","box":"style_box__XLCZI","active":"style_active__3nt01","title":"style_title__tFWT4","item":"style_item__dF9tk"};